var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 34,
    height: 34,
    rx: 4.5,
    fill: "white",
    stroke: "#F8F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3872_1237)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6951 6.70915C19.6951 6.70915 20.4615 8.9327 20.4615 8.93166C21.099 9.20489 21.7007 9.55275 22.2553 9.9682L24.5648 9.52001C24.8329 9.46784 25.1091 9.56299 25.2892 9.76868C26.2255 10.8431 26.9449 12.0884 27.4064 13.437C27.4954 13.6959 27.4391 13.9824 27.26 14.1891C27.26 14.1891 25.718 15.9644 25.718 15.9634C25.7999 16.6521 25.7999 17.3479 25.718 18.0355L27.26 19.8108C27.4391 20.0175 27.4954 20.304 27.4064 20.5629C26.9449 21.9116 26.2255 23.1568 25.2892 24.2313C25.1091 24.437 24.8329 24.5321 24.5648 24.4799C24.5648 24.4799 22.2553 24.0317 22.2563 24.0317C21.7007 24.4472 21.098 24.7951 20.4615 25.0673L19.6951 27.2908C19.6061 27.5497 19.3861 27.741 19.118 27.7942C17.7192 28.0685 16.2805 28.0685 14.8817 27.7942C14.6136 27.741 14.3936 27.5497 14.3046 27.2908C14.3046 27.2908 13.5382 25.0673 13.5382 25.0683C12.9007 24.7951 12.2991 24.4472 11.7444 24.0317L9.43495 24.48C9.16685 24.5322 8.89057 24.437 8.71048 24.2313C7.77418 23.1569 7.05485 21.9116 6.59335 20.5629C6.5043 20.304 6.5606 20.0176 6.73965 19.8109C6.73965 19.8109 8.28172 18.0355 8.28172 18.0365C8.19986 17.3479 8.19986 16.6521 8.28172 15.9644L6.73969 14.1891C6.56064 13.9824 6.50434 13.6959 6.59335 13.437C7.05485 12.0884 7.77418 10.8431 8.71044 9.76864C8.89053 9.56295 9.16681 9.4678 9.43491 9.52001C9.43491 9.52001 11.7444 9.9682 11.7434 9.9682C12.299 9.55275 12.9017 9.20485 13.5382 8.93266L14.3046 6.70915C14.3936 6.45028 14.6136 6.25891 14.8817 6.2057C16.2804 5.93147 17.7191 5.93147 19.118 6.2057C19.3861 6.25891 19.6061 6.45024 19.6951 6.70915ZM16.9999 12.4762C14.5031 12.4762 12.476 14.5033 12.476 17.0001C12.476 19.4968 14.5031 21.5238 16.9999 21.5238C19.4966 21.5238 21.5237 19.4968 21.5237 17C21.5237 14.5033 19.4966 12.4762 16.9999 12.4762ZM16.9999 14.0111C18.6493 14.0111 19.9888 15.3506 19.9888 17C19.9888 18.6495 18.6493 19.9889 16.9999 19.9889C15.3504 19.9889 14.0109 18.6495 14.0109 17C14.0109 15.3505 15.3504 14.0111 16.9999 14.0111Z",
    fill: "url(#paint0_linear_3872_1237)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3872_1237",
    x1: 16.9998,
    y1: 6.00003,
    x2: 16.9998,
    y2: 27.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7705",
    stopOpacity: 0.88
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E60000",
    stopOpacity: 0.81
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3872_1237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(6 6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.2613936f0e7e16e94a92d35bf5b5f9e4.svg";
export { ForwardRef as ReactComponent };